const BaseModel = require('./BaseModel');
const SurveyReport = require('./Survey/SurveyReport');
const HTTPClient = require('../HTTPClient');

class Survey extends BaseModel {
  static basePath = '/api/v1/surveys';
  static dataType = 'survey';

  constructor(json) {
    super(json);
    this.parseToDates(['startedAt', 'scheduleStartAt', 'scheduleCloseAt', 'closedAt']);

    this.close = this.close.bind(this);
    this.distribute = this.distribute.bind(this);
    this.linkContacts = this.linkContacts.bind(this);
    this.schedule = this.schedule.bind(this);
    this.getContactFilters = this.getContactFilters.bind(this);
    this.updateContactFilters = this.updateContactFilters.bind(this);
  }

  get isDraft() { return (this.state == 'draft') }
  get isReady() { return (this.state == 'ready') }
  get isScheduled() { return (this.state == 'scheduled') }
  get isLinking() { return (this.state == 'linking') }
  get isLive() { return (this.state == 'live') }
  get isClosed() { return (this.state == 'closed') }

  get canClose() { return (this.isLive) }
  get canLinkContacts() { return (this.isDraft || this.isReady || this.isScheduled || this.isLive) }
  get canSchedule() { return (this.isReady || (this.isDraft && (this.settings?.allowAnonymous || this.settings?.autoInvite))) }
  get canStart() { return (this.isScheduled || this.isReady || (this.isDraft && (this.settings?.allowAnonymous || this.settings?.autoInvite))) }

  get hasStarted() { return (this.isLive || this.isClosed) }

  close() {
    const path = `${this.constructor.basePath}/${this.id}/close`;
    return new HTTPClient().post(path).then(this);
  }

  distribute() {
    const path = `${this.constructor.basePath}/${this.id}/distribute`;
    return new HTTPClient().post(path).then(this);
  }

  linkContacts() {
    const path = `${this.constructor.basePath}/${this.id}/link-contacts`;
    return new HTTPClient().post(path).then(this);
  }

  schedule() {
    const path = `${this.constructor.basePath}/${this.id}/schedule`;
    return new HTTPClient().post(path).then(this);
  }

  getContactFilters() {
    const path = `${this.constructor.basePath}/${this.id}/contact-filters`;
    return new HTTPClient().get(path).then(results => BaseModel._parseDataItemArray(results));
  }

  static updateContactFilters(survey, filters) {
    const path = `${this.basePath}/${survey.id}/contact-filters`;
    return new HTTPClient().post(path, filters).then(results => BaseModel._parseDataItemArray(results));
  }

  updateContactFilters(filters) {
    return (Survey.updateContactFilters(this, filters));
  }
}

Survey.Report = SurveyReport;

BaseModel.models[Survey.dataType] = Survey;
module.exports = Survey;
